const getBaseUrl = () => {
     if (process.env.NODE_ENV !== 'development'){
          return 'https://talnet.co' 
     }
     else {
          return 'http://localhost:3000'
     }
}

export default getBaseUrl